import React from "react";
import moment from "moment";
import firebase from 'firebase';
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { existeFecha, callService, goTo } from "../tools";
import { validacionEmail, validacionTel } from "../miPerfil/servicios.act";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import StepperPaso2 from '../stepper-gnp-registro/stepper-paso2.cmpt';
import StepperResposnsivo2 from '../stepper-gnp-registro/stepper-responsivo2.cmpt';
import { servicios } from './../properties';
import MensajeAyuda from "../modal-ayuda-registro/modal-ayuda-registro.cmpt";

const mensajeEdadTexto = "Para completar su registro debe ser mayor de edad.";
const campoReq = "Campo requerido";
const modal1 = "#modal-validacion1";
const modalRegInc = "#modal-registro-inconcluso";
const elementID = "btn-continuar-datos";
const estiloSolid = '2px solid #F44336';
let validacionT = false;
let validacionC = false;
let contador, contador2 = 0;

const mapState = (state) => {
	let fechaNacimientoDate = "";
	let dia = "", mes = "", anio = "";

	if (state.registro.fechaNacimientoDate === "") {
		fechaNacimientoDate = state.registro.fechaDeNacimientoDate;
	} else {
		fechaNacimientoDate = state.registro.fechaNacimientoDate;
	}

	if (state.registro.fechaNacimientoDate !== "") {
		const date = new Date(state.registro.fechaNacimientoDate);
		dia = (date.getDate() < 10) ? "0" + date.getDate() : date.getDate();
		mes = (date.getMonth() + 1 < 10) ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
		anio = date.getFullYear();
	}
	return {
		ramo: state.registro.ramo,
		grupo: state.registro.configuracion.grupo,
		poliza: state.registro.poliza,
		certificado: state.registro.certificado,
		dispositivo: state.global.dispositivo,
		fechaDeNacimiento: state.registro.fechaDeNacimiento,
		fechaDeNacimientoDate: state.registro.fechaDeNacimientoDate,
		polizaBanamex: state.registro.polizaBanamex,
		rfc: state.registro.rfcbnmx,
		email: state.registro.email,
		telefono_movil: state.registro.telCelular,
		initialValues: {
			email: state.registro.email,
			email_confirm: state.registro.email,
			fechaNacimiento: state.registro.fechaNacimiento,
			fechaNacimientoDate: fechaNacimientoDate,
			lada_fijo: state.registro.ladaFijo,
			telefono_fijo: state.registro.telFijo,
			lada_movil: state.registro.ladaCelular,
			telefono_movil: state.registro.telCelular,
			apaterno: state.registro.apaterno,
			amaterno: state.registro.amaterno,
			nombres: state.registro.nombres,
			dia: dia,
			mes: mes,
			anio: anio
		}
	};
};

const mapDispatch = (dispatch) => {
	return {
		regresar: (disp) => {
			dispatch({ "type": "EVENT_REGISTRO_DP-REGRESAR", "dispositivo": disp });
			dispatch({ "type": "REGISTRO_PASO", "paso": 0 });
		},
		avisoPrivacidad: (showAviso) => {
			dispatch({ "type": "AVISO_PRIVACIDAD", "showAviso": showAviso });
		},
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const telefono = tipo => (value, campos) => {
	const numero = (value !== undefined) ? value.replace("+", "").replace(" ", "") : "";
	const prefijo = (/lada/g.test(tipo)) ? "+" : "";

	if (numero !== "") {
		campos[tipo] = prefijo + ((/lada/g.test(tipo)) ? numero.substr(0, 3) : numero);
	} else {
		campos[tipo] = "";
	}

	if (numero !== "" && isNaN(numero)) {
		let _temp = "";
		for (let i = 0; i < numero.length; i++) {
			if (!isNaN(numero.substr(i, 1))) {
				_temp += numero.substr(i, 1);
			}
		}
	}
};

const espacios = tipo => (value, campos) => {
	let texto = (value !== undefined && value !== " ") ? value : "";
	texto = texto.replace(/\s{2,}/g, " ");
	campos[tipo] = texto;
};

const onSubmitFail = (errors, dispatch, submitError, props) => {
	if (errors.poliza === campoReq || errors.dia === campoReq) {
		dispatch({ "type": "EVENT_REGISTRO_DP-VACIOS", "dispositivo": props.dispositivo });
	} else {
		dispatch({ "type": "EVENT_REGISTRO_DP-INCORRECTOS", "dispositivo": props.dispositivo });
	}
};

const campoSettings = {
	fontFamily: 'Open Sans',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#567099'
}

const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#FF6B0B',
}

const campo = ({ input, label, max, type, focus, blur, change, error }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				value={input.value}
				name={input.name}
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				onFocus={(event) => { input.onFocus(event); }}
				onBlur={(event) => { input.onBlur(event); }}
				onChange={(event) => { input.onChange(event); }}
				maxLength={max}
				errorText={error}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						handleKeyPress(input);
					}
				}}
			/>
		</MuiThemeProvider>
	);
};

const handleKeyPress = (input) => {
	const inputs = document.getElementsByTagName('input');
	const inputActual = input.name;
	for (const i of inputs) {
		if (inputActual === i.name) {
			switch (i.name) {
				case "telefono_movil":
					document.getElementById(i.id).blur();
					break;
				case "fechaNacimiento":
					if (i.id !== "") {
						document.getElementById(i.id).blur();
						document.getElementById(elementID).focus();
					}
					break;
				default:
					break;
			}
		}
	}
}

const validate = (campos) => {
	const errors = {};

	if (campos.email) {
		campos.email = campos.email.replace(" ", "");

		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(campos.email)) {
			errors.email = "El correo electrónico no es válido. Favor de verificar.";
		}
	}

	if (existeFecha(campos.dia, campos.mes, campos.anio) === false) {
		errors.dia = "La fecha introducida es inválida.";
	}

	if (campos.fechaNacimiento === "") {
		errors.fechaNacimiento = campoReq
	}
	return errors;
};

const valorV = (val) => {
	if (val === "") {
		document.getElementById("input").innerHTML = "";
		document.getElementById("complete").innerHTML = '';
	}
}

const eventoEnter = (val, e, name) => {
	const inputs = document.getElementsByTagName('input');

	const inputActual = input.name;
	if (e.keyCode === 32 || e.keyCode === 9 || e.keyCode === 39) {
		e.preventDefault();
		document.getElementById("input").value = val.substring(0, val.indexOf("@", 0) + 1) + name;
		document.getElementById('complete').innerHTML = '';
	} else if (e.keyCode === 13) {
		document.getElementById("input").value = val.substring(0, val.indexOf("@", 0) + 1) + name;
		document.getElementById('complete').innerHTML = '';
		for (let index = 0; index < inputs.length; index++) {
			if (inputActual === inputs[index].name) {
				document.getElementById(inputs[index + 1].id).focus();
			}
		}

	}
}

const completarDominio = (find, val, name) => {
	if (find === true) {
		const nombreEmail = val.substring(0, val.indexOf("@", 0) + 1);
		document.getElementById("complete").innerText = nombreEmail + name;
	} else {
		document.getElementById("complete").innerText = '';
	}
}

const style = {
	color: "red",
	border: "none",
	marginTop: "-10px",
	position: "absolute"
}

class Datos extends React.Component {
	cont = 0;
	errorsCorreo = false;
	errorCountCorreo1 = false;
	errorCountCorreo2 = false;
	errorsTelefono = false;
	msjaMostrar = "";
	correoContinua = false;
	telefonoContinua = false;
	correosValidados = [];
	telefonosValidados = [];
	contadorCorreo = 0;
	contadorCelular = 0;
	contadorFijo = 0;
	valorLadaCel = '';
	valorLadaFijo = '';
	idOperacionOTP = "";
	state = {
		claseFlecha: "",
		tituloOne: "",
		mensajeOne: "",
		habilitarBoton: true,
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
		inputType3: "",
		messageEdadBandera: false,
		mensajeEdad: "",
		showModalAyuda: false,
        tipoModalAyuda: "",
	}

	clasesLabel = "textoLabelCorreo";

	componentWillMount = () => {
		$(modal1).modal("hide");
		const correoRegresar = localStorage.getItem("correo");

		if (this.props.initialValues.email !== '' && this.props.initialValues.telefono_movil !== '' &&
			this.props.initialValues.fechaNacimiento !== '') {
			this.setState({ habilitarBoton: false });
			this.correoContinua = true;
			this.telefonoContinua = true;
			this.setState({ inputType3: 'date' });
		}

		if (correoRegresar === "true") {
			setTimeout(() => {
				document.getElementsByClassName("inputEmail")[0].value = this.props.initialValues.email;
				var elemento = document.getElementsByClassName("textoLabelCorreo");
				elemento[0].className = 'textoLabelCorreoLleno';
			}, 500);
		}
	}

	handleScroll = (event) => {
		if (event.currentTarget.scrollTop > 130) {
			this.setState({ claseFlecha: "up" });
		} else if (event.currentTarget.scrollTop > 40) {
			this.setState({ claseFlecha: "left" });
		} else {
			this.setState({ claseFlecha: "" });
		}
	}

	handleChange = () => {
		$(modal1).modal("hide");
		const fecha = document.getElementsByName("fechaNacimiento")[0].value;
		const transformada = fecha.split("-");
		if (transformada[0] > "9999") {
			fecha.value = "";
		}
		this.getFechaNacimiento();
		this.habilitaBoton();
	}

	regresar = () => {
		$(modalRegInc).modal('hide');
		$("#modal-otp").modal('hide');
		this.props.avisoPrivacidad(true);
		this.props.regresar(this.props.dispositivo);
		this.props.tagManager({ "type": "REGISTRO_POLIZA_REGRESAR_DATOS", "dispositivo": this.props.dispositivo });
	}

	getFechaNacimiento = () => {
		const fechaNacimiento = document.getElementsByName("fechaNacimiento")[0].value;
		const dia = fechaNacimiento.substr(8, 9);
		const mes = fechaNacimiento.substr(5, 2);
		const anio = fechaNacimiento.substr(0, 4);

		if (fechaNacimiento !== "") {
			const date = new Date(fechaNacimiento);
			this.props.change("fechaDeNacimiento", moment(anio + "-" + mes + "-" + dia, "YYYY-MM-DD").format("DD - MMMM - YYYY"));
			this.props.change("fechaDeNacimientoDate", date.getTime());

			return dia + "/" + mes + "/" + anio;
		} else {
			return '';
		}
	}

	codigoCompleto = () => {
		const inputCodigo = document.getElementsByName('codigo_verificacion')[0].value;
		inputCodigo.length >= 8 ? this.habilitaBTNOTP(false) : this.habilitaBTNOTP(true);
	}

	handleBlurCorreo = () => {
		document.getElementById('complete').innerHTML = '';
		setTimeout(() => {
			const email = document.getElementsByClassName("inputEmail")[0].value;
			this.props.change("email", email);

			if (email === "" || email === undefined) {
				this.emailVacio();
			} else if (email !== "" && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
				this.emailLlenoCorrecto(email);
			} else if (email !== "" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
				this.errorCorreoInc = true
				this.emailLleno();
			} else {
				this.correoContinua = false;
			}
		}, 10);
	}

	emailVacio = () => {
		console.log('email vacioo');
		let elemento = document.getElementsByClassName("textoLabelCorreoFocus")[0];
		const elemento2 = document.getElementsByClassName("textoLabelCorreoLleno")[0];
		const emailV = document.getElementsByClassName("inputEmail")[0].value;

		if (emailV === "") {
			if (elemento !== undefined) {
				elemento.className = 'textoLabelCorreo';

			}
			if (elemento2 !== undefined) {
				elemento2.className = 'textoLabelCorreo';
			}
			this.errorsCorreo = true;
			this.erroresEmail();
		} else {
			if (elemento === undefined) {
				elemento = document.getElementsByClassName("textoLabelCorreoLleno")[0];
				elemento.className = 'textoLabelCorreo';
			} else {
				elemento.className = 'textoLabelCorreo';
			}
		}
	}

	emailLlenoCorrecto = (email) => {
		this.correoContinua = true;
		this.errorsCorreo = false;
		this.erroresEmail();
		const elemento = document.getElementsByClassName("textoLabelCorreoFocus")[0];

		if (elemento !== undefined) {
			elemento.className = 'textoLabelCorreoLleno';
		}

		if (!this.correosValidados.hasOwnProperty(email)) {
			validacionEmail(email)
				.then(response => {
					const isValid = response.data;
					this.correosValidados[email] = isValid;

					console.log("Respuesta validacionEmail", isValid);
					this.validacionCorrecta(isValid);
				})
		} else {
			this.correosValidadosFuncion(this.correosValidados[email]);
		}
	}

	emailLleno = () => {
		this.errorsCorreo = true;
		this.correoContinua = false;

		if (document.getElementsByClassName("textoLabelCorreoFocus")[0] !== undefined) {
			document.getElementsByClassName("textoLabelCorreoFocus")[0].className = 'textoLabelCorreoLleno';
		}
		this.erroresEmail();
	}

	handleFocusEmail = () => {
		$(modal1).modal("hide");
		let elemento = '';
		const email = document.getElementsByClassName("inputEmail")[0].value;

		if (email === "" || email === undefined) {
			elemento = document.getElementsByClassName("textoLabelCorreo")[0];
			elemento.className = 'textoLabelCorreoFocus';
			if (elemento === '') {
				elemento = document.getElementsByClassName("textoLabelCorreoLleno")[0];
				elemento.className = 'textoLabelCorreo';
			}
		}
	}

	handleKeyupEmail = (event) => {
		let find = false;
		this.correoLleno();
		let name = '';
		const val = event.target.value;
		$(modal1).modal("hide");

		const names = [
			'gmail.com',
			'yahoo.com',
			'gnp.com.mx',
			'google.com',
			'hotmail.com',
			'me.com',
			'aol.com',
			'mac.com',
			'live.com',
			'comcast.net',
			'googlemail.com',
			'msn.com',
			'hotmail.co.uk',
			'yahoo.co.uk',
			'facebook.com',
			'verizon.net',
			'sbcglobal.net',
			'att.net',
			'gmx.com',
			'mail.com',
			'outlook.com',
			'icloud.com'
		];

		if ((val).includes("@")) {
			valorV(val);
			for (var i = 0; i < names.length; i++) {
				name = names[i];
				const domain = val.substring(val.indexOf("@", 0) + 1, val.length);
				if (name.indexOf(domain) === 0) {
					find = true;
					break;
				} else {
					name = '';
				}
			}
			eventoEnter(val, event, name)
			completarDominio(find, val, name);
		}
	}

	validacionCorrecta = (bandera) => {
		if (bandera) {
			this.errorsCorreo = false;
			validacionC = true;
			this.validaDosBanderas();
		} else {
			this.countCorreo();
		}
	}

	correosValidadosFuncion = (correosArray) => {
		if (!correosArray) {
			setTimeout(() => {
				this.countCorreo();
			}, 1000);
		} else {
			this.correoContinua = true;
		}
	}

	countCorreo = () => {
		this.contadorCorreo++;
		console.log('entra a contador', this.contadorCorreo);

		if (this.contadorCorreo === 1) {
			const elemento = document.getElementsByClassName("textoLabelCorreoLleno")[0];
			elemento.className = 'textoLabelCorreo';
			document.getElementById('complete').innerHTML = '';
			this.props.change("email", "");
			document.getElementById('input').value = '';
			this.errorCountCorreo1 = true;
			this.errorCountCorreo2 = false;
			this.errorsCorreo = true;
			this.erroresEmail();
		} else if (this.contadorCorreo === 2) {
			this.errorCountCorreo1 = false;
			this.errorCountCorreo2 = true;
			this.errorsCorreo = true;
			validacionC = true;
			this.erroresEmail();
		}
		setTimeout(() => {
			this.habilitaBoton();
		}, 500);
	}

	handlefocusCel = () => {
		$(modal1).modal("hide");
		if (this.cont === 0) {
			this.muestraTooltip(true, 'informativo', 'Establecer teléfono de contacto',
				`El teléfono celular sera utilizado como medio de contacto para notificarte operaciones
			realizadas o enviarte codigos de verificación requeridos en algunas transacciones.`);
			setTimeout(() => {
				this.muestraTooltip(false);
			}, 3000);
		}
		this.cont += 1;
	}

	handleBlurCel = () => {
		$(modal1).modal("hide");
		if (this.cont === 1) {
			setTimeout(() => {
				this.muestraTooltip(false);
			}, 3000);
		}
		const celCompleto = document.getElementsByName("telefono_movil")[0].value;
		if (celCompleto !== "" && celCompleto.length === 10 && /^[0-9]+/.test(celCompleto)) {
			this.telefonoContinua = false;
			this.validacionesTel('reinicia');

			if (!this.telefonosValidados.hasOwnProperty(celCompleto)) {
				validacionTel(celCompleto)
					.then(response => {
						const isValid = response.data.validacionMedioContacto;
						this.telefonosValidados[celCompleto] = isValid;
						this.validacionCorrectaTelefono(isValid);
						this.handlePressSiguiente();
					})
			} else {
				this.telefonosValidadosFuncion(this.telefonosValidados[celCompleto]);
				this.handlePressSiguiente();
			}
		} else if ((celCompleto !== "" && !/^[0-9]+/.test(celCompleto)) ||
			celCompleto.length === 10 && !/^[0-9]+/.test(celCompleto)) {
			this.validacionesTel('solonumeros');
			this.telefonoContinua = false;
		} else {
			this.validacionesTel('formato');
			this.telefonoContinua = false;
		}
	}

	handlePressSiguiente = () => {
		const inputs = document.getElementsByTagName('input');
		setTimeout(() => {
			for (const i of inputs) {
				if (this.props.polizaBanamex === false) {
					if ("fechaNacimiento" === i.name) {
						document.getElementById(i.id).focus();
					}
				} else {
					setTimeout(() => {
						document.getElementById(elementID).focus();
					}, 500);
				}
			}
		}, 1000);
	}

	validacionCorrectaTelefono = (bandera) => {
		if (bandera) {
			this.telefonoContinua = true;
			validacionT = true;
			this.validacionesTel('reinicia');
			this.validaDosBanderas();
		} else {
			this.countCelular();
		}
	}

	validaDosBanderas = () => {
		var AñofechaNacimiento;
		if (localStorage.getItem('fechaNacimientoBMX') !== null) {
			AñofechaNacimiento = moment(localStorage.getItem('fechaNacimientoBMX')).format('YYYY');
		} else {
			AñofechaNacimiento = moment(document.getElementsByName("fechaNacimiento")[0].value).format('YYYY');
		}
		
		var AñofechaActual = moment().format('YYYY');
		var edadAños = (parseInt(AñofechaActual) - parseInt(AñofechaNacimiento));
		
		if (edadAños >= 18) {
			this.setState({ messageEdadBandera: false });
			this.setState({ mensajeEdad: "" });
			if (validacionT && validacionC) {
				this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
			}
		} else {
			this.setState({ messageEdadBandera: true });
			this.setState({ mensajeEdad: mensajeEdadTexto });
		}
	}

	telefonosValidadosFuncion = (arraytelefonos) => {
		if (!arraytelefonos) {
			setTimeout(() => {
				this.countCelular();
			}, 1000);
		} else {
			this.telefonoContinua = true;
		}
	}

	validacionesTel = (value) => {
		if (value === 'solonumeros') {
			this.errorsTelefono = true;
			this.msjaMostrar = "Este campo solo acepta numeros.";
			return this.msjaMostrar;
		} else if (value === 'formato') {
			this.errorsTelefono = true;
			this.msjaMostrar = campoReq;
			return this.msjaMostrar;
		} else if (value === "validacion1") {
			this.errorsTelefono = true;
			this.msjaMostrar = "Verifica que tu teléfono sea correcto.";
			return this.msjaMostrar;
		} else if (value === "validacion2") {
			this.errorsTelefono = true;
			this.msjaMostrar = "Asegúrate de ingresar un teléfono válido para continuar tu registro.";
			return this.msjaMostrar;
		}
		else {
			this.errorsTelefono = false;
			return this.msjaMostrar;
		}
	}

	countCelular = () => {
		this.contadorCelular++;
		if (this.contadorCelular === 1) {
			this.validacionesTel("validacion1");
			document.getElementsByName('telefono_movil')[0].focus();
			this.props.change("telefono_movil", "");
		} else if (this.contadorCelular === 2) {
			this.validacionesTel("validacion2");
			this.contadorCelular = 0;
			validacionT = true;
		}
		if (this.props.polizaBanamex === false) {
			if ("fechaNacimiento" === inputs.name) {
				document.getElementById(inputs.id).focus();
			}
		} else {
			setTimeout(() => {
				document.getElementById(elementID).focus();
			}, 500);
		}
	}

	actualizaPersona = (oForm) => {
		const $this = this;
		$this.props.loader(true);

		new callService({
			service: "utilerias.actualizaPersona",
			secure: true,
			data: {}
		}).execute().then((oResult) => {
		}).catch((error) => {
			console.log("Error", error);

		});
	}

	componentDidMount = () => {
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];
		const banConcluirRegPoliza = localStorage.getItem("banConcluirRegPoliza");
		const banConcluirReg = localStorage.getItem("banConcluirReg");
		const correoRegresar = localStorage.getItem("correo");

		if (localStorage.getItem("email") !== "" || localStorage.getItem("email") !== null) {
			document.getElementsByClassName("inputEmail")[0].value = localStorage.getItem("email");
		}

		if (url.includes("#!/gnp/registro")) {
			main.style.maxHeight = "100%";
			main.style.paddingBottom = "30px";
			main.style.overflow = "hidden auto";
		}

		if ((banConcluirReg && banConcluirReg === "false") || (banConcluirRegPoliza && banConcluirRegPoliza === "false")) {
			this.separaCorreo();
			$(modalRegInc).modal({ backdrop: "static", keyboard: false });
		} else {
			localStorage.setItem("labelRegInc", "false");
			this.clasesLabel = "textoLabelCorreo";
			localStorage.removeItem("banConcluirReg");
			localStorage.removeItem("banConcluirReg");
		}
		if (correoRegresar === "true") {
			this.habilitaBoton();
		}
	}

	separaCorreo = () => {
		let email = localStorage.getItem("correoModal");
		const dominio = email.substring(email.indexOf("@", 0), email.length)
		if (email !== "") {

			email = email.substring(0, email.indexOf("@", 0));
			let element = "";
			for (let index = 0; index < email.length - 5; index++) {
				element += '•';
			}
			this.correoModal = element + email.substring(email.length - 5, email.length) + dominio;
		} else {
			email = localStorage.getItem("email");
			if (email !== "") {

				email = email.substring(0, email.indexOf("@", 0));

				let element = "";
				for (let index = 0; index < email.length - 5; index++) {
					element += '•';
				}
				this.correoModal = element + email.substring(email.length - 5, email.length) + dominio;
			}
		}
	}

	registroInconclusoCorreo = () => {
		const correo = localStorage.getItem("correoInconcluso");

		new callService({
			service: "registro.incConsultaRegistro",
			secure: true,
			data: {
				correo: correo.toLowerCase()
			}
		}).execute().then((respuesta) => {

			if (respuesta.banConcluirReg.toString() === 'false') {
				localStorage.setItem("labelRegInc", "true");
				localStorage.setItem("hashOne", respuesta.path);
				new callService({
					service: "registro.incConsultaDatosReg",
					secure: true,
					data: {
						uid: respuesta.path
					}
				}).execute().then((respuestaC) => {
					this.props.change("email", respuestaC.email);
					document.getElementsByClassName("inputEmail")[0].value = respuestaC.email;
					this.props.change("telefono_movil", respuestaC.ladaCelular + respuestaC.telCelular);
					this.clasesLabel = "textoLabelCorreoLleno";
					if (respuestaC.fechaNacimiento !== undefined) {
						const anio = respuestaC.fechaNacimiento.substr(0, 3);
						const mes = respuestaC.fechaNacimiento.substr(4, 5);
						const dia = respuestaC.fechaNacimiento.substr(6, 7);
						const fechaNacimiento = anio + "-" + mes + "-" + dia;
						this.setState({ inputType3: 'date' });
						this.props.change("fechaNacimiento", fechaNacimiento);
					}
					this.openModal(respuestaC);
				}).catch((error) => {
					console.log("Error", error);
				});
			} else {
				localStorage.setItem("labelRegInc", "false");
				if (correoRegresar === "true") {
					this.clasesLabel = "textoLabelCorreoLleno";
				} else {
					this.clasesLabel = "textoLabelCorreo";
				}
				localStorage.removeItem("banConcluirReg");
				localStorage.removeItem("hashOne");
			}
		}).catch((error) => {
			console.log("Error", error);
		});
	}

	registroInconclusoPoliza = () => {
		const poliza = localStorage.getItem("poliza");
		const certificado = localStorage.getItem("certificado");
		const sistema = localStorage.getItem("sistema");

		new callService({
			service: "registro.incConsultaRegistroPoliza",
			secure: true,
			data: {
				poliza: poliza,
				certificado: certificado,
				sistema: sistema,
			}
		}).execute().then((respuesta) => {
			if (respuesta.banConcluirReg === false) {
				localStorage.setItem("hashOne", respuesta.path);
				localStorage.setItem("labelRegInc", "true");
				new callService({
					service: "registro.incConsultaDatosReg",
					secure: true,
					data: {
						uid: respuesta.path
					}
				}).execute().then((respuestaP) => {
					this.props.change("email", respuestaP.email);
					document.getElementsByClassName("inputEmail")[0].value = respuestaP.email;
					this.props.change("telefono_movil", respuestaP.ladaCelular + respuestaP.telCelular);
					this.clasesLabel = "textoLabelCorreoLleno";
					const fechaNacimiento = respuestaP.fechaNacimiento;
					this.setState({ inputType3: 'date' });
					this.props.change("fechaNacimiento", fechaNacimiento);
					this.openModal(respuestaP);
				}).catch((error) => {
					console.log("Error", error);
				});
			} else {
				localStorage.setItem("labelRegInc", "false");
				this.clasesLabel = "textoLabelCorreo";
				localStorage.removeItem("banConcluirReg");
				localStorage.removeItem("hashOne");
			}
		}).catch((error) => {
			console.log("Error", error);
		});
	}

	openModal = (respuesta2) => {
		localStorage.setItem("cveClienteUnico", respuesta2.cveClienteUnico);
		this.props.registroInconcluso(respuesta2);
	}

	correoLleno = () => {
		const correo = document.getElementById("input").value;

		if (correo !== "") {
			const elemento = document.getElementsByClassName("textoLabelCorreo");
			elemento.className = 'textoLabelCorreoLleno';
		}
	}

	habilitaBoton = () => {
		$(modal1).modal("hide");
		var dateNacimiento = document.getElementsByName("fechaNacimiento")[0].value;
		var correo = document.getElementsByName("email")[0].value;
		var celular = document.getElementsByName("telefono_movil")[0].value;

		const correoRegresar = localStorage.getItem("correo");
		if (dateNacimiento === "") {
			if (this.props.initialValues.fechaNacimientoDate === "" || !this.correoContinua || !this.telefonoContinua) {
				this.setState({ habilitarBoton: true });
			}
			else {
				this.setState({ habilitarBoton: false });
			}
		} else if (dateNacimiento === "" || !this.correoContinua || !this.telefonoContinua) {
			this.setState({ habilitarBoton: true });
		}
		else {
			this.setState({ habilitarBoton: false });
		}

		if (correoRegresar === "true") {
			if (dateNacimiento !== "" && correo !== "" && celular !== "") {
				this.setState({ habilitarBoton: false });
				document.getElementById(elementID).focus();
			}
			localStorage.removeItem("correo");
		}
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
        if(show) {
            if(type === "error" || type === undefined) {
                contador = contador +1;
    
                if(contador <= 2) {
                    setTimeout(() => {
                        this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
                    }, 300);
                }
                else {
                    this.muestraTooltip(false);
                    this.muestraModalAyuda();
                }
            } else {
                setTimeout(() => {
                    this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
                }, 300);
            }
        }
    }

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	cierraTooltip2 = e => {
        this.setState({
            showModalAyuda: !this.state.showModalAyuda 
        });
    }

	onFocusFechaNacimiento2 = (event) => {
		var dia = "";
		var mes = "";
		var anio = "";

		$(modal1).modal("hide");
		this.setState({ inputType3: "date" });
		dia = event.currentTarget.value.substr(8, 9);
		mes = event.currentTarget.value.substr(5, 2);
		anio = event.currentTarget.value.substr(0, 4);
		document.getElementsByName("fechaNacimiento")[0].value = dia + "/" + mes + "/" + anio;
	}

	onBlurFechaNacimiento = () => {
		$(modal1).modal("hide");
		this.setState({ inputType3: 'text' });
		if (document.getElementsByName("fechaNacimiento")[0].value.includes("-")) {
			this.setState({ inputType3: 'date' });
		}
	}

	erroresEmail = () => {
		if (this.errorsCorreo) {
			const spanCorreo = document.getElementsByClassName("correoValido")[0];

			if (spanCorreo !== undefined) {
				spanCorreo.className = 'spanCorreo';
			}
			const email = document.getElementsByClassName("inputEmail")[0];

			if (email !== undefined) {
				if (this.errorCountCorreo1 === true) {
					email.style.borderBottom = estiloSolid;
					document.getElementsByClassName("spanCorreo")[0].innerHTML = "Verifica que tu correo sea correcto.";
				} else if (this.errorCountCorreo2 === true) {
					console.log('entra en el error 2');
					email.style.borderBottom = estiloSolid;
					document.getElementsByClassName("spanCorreo")[0].innerHTML = "Asegúrate de ingresar un correo válido para continuar tu registro.";
				}
				else {
					email.style.borderBottom = estiloSolid;
					document.getElementsByClassName("spanCorreo")[0].innerText = campoReq;
					
				}
			} else if (this.errorCorreoInc) {
				email.style.borderBottom = estiloSolid;
				document.getElementsByClassName("spanCorreo")[0].innerHTML = "El correo electrónico no es válido. Favor de verificar.";
				this.muestraModalAyuda();
			} else {
				document.getElementsByClassName("spanCorreo")[0].innerHTML = "";
			}
		} else {
			this.props.change("email", document.getElementsByName("email").value);
			const email = document.getElementsByClassName("inputEmail")[0];
			email.style.borderBottom = '1.2px solid #aac3ee';
			document.getElementsByClassName("spanCorreo")[0].innerHTML = "";
		}
	}

	continuarInconcluso = () => {
		const banConcluirRegPoliza = localStorage.getItem("banConcluirRegPoliza");
		const banConcluirReg = localStorage.getItem("banConcluirReg");
		$(modalRegInc).modal('hide');
		if (banConcluirReg && banConcluirReg === "false") {
			this.registroInconclusoCorreo();
		} else if (banConcluirRegPoliza && banConcluirRegPoliza === "false") {
			this.registroInconclusoPoliza();
		}
	}

	cancelarInconcluso = () => {
		$(modalRegInc).modal('hide');
		$("#modal-otp").modal('hide');
		localStorage.setItem('cancelarRegInc', true);
		firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
			var data = oValue.val();
			if (!data) {
				goTo("login");
			} else {
				window.location.assign(servicios.dominioReingenieria);
			}
		})
	}

	expandir = () => {
		var mostrar = document.getElementById("steppervertical");
		if (mostrar.style.display === "block") {
			mostrar.style.display = "none";
		} else {
			mostrar.style.display = "block";
		}
	}

	handleBlurRFC = () => {
		const rfc = document.getElementsByName("rfc")[0].value;
		const nacimiento = document.getElementsByName("fechaNacimiento")[0].value;

		if (/^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/.test(rfc) === false && rfc !== "") {
			this.setState({ mensajeErrorRFC: true });
			this.setState({ mensajeRFC: "Formato de RFC inválido." });
		} else if (rfc && nacimiento) {
			const dia = nacimiento.substr(8, 9);
			const mes = nacimiento.substr(5, 2);
			const anio = nacimiento.substr(0, 4);
			var fechaComparativa = anio.substr(2, 4) + mes + dia;

			if (rfc.substr("4", "6") !== fechaComparativa) {
				this.setState({ mensajeErrorRFC: true });
				this.setState({ mensajeRFC: "El RFC no concuerda con la fecha de nacimiento." });
			} else {
				this.setState({ mensajeErrorRFC: false });
				this.setState({ mensajeRFC: "" });
			}
		}
	}

	whatIWantToRunOnSubmit = (values) => {
		let AñofechaNacimiento;
		$(modal1).modal("hide");

		if (localStorage.getItem('fechaNacimientoBMX') !== null) {
			AñofechaNacimiento = moment(localStorage.getItem('fechaNacimientoBMX')).format('YYYY');
		} else {
			AñofechaNacimiento = moment(values.fechaNacimiento).format('YYYY');
		}

		const AñofechaActual = moment().format('YYYY');
		const edadAños = (parseInt(AñofechaActual) - parseInt(AñofechaNacimiento));

		if (edadAños >= 18) {
			this.setState({ messageEdadBandera: false });
			this.setState({ mensajeEdad: "" });
			if (validacionT && validacionC) {
				this.props.onSubmit({ ...values });
			}
		} else {
			if (values.fechaNacimiento !== '') {
				this.setState({ messageEdadBandera: true });
				this.setState({ mensajeEdad: mensajeEdadTexto });
			} else {
				this.setState({ messageEdadBandera: true });
				this.setState({ mensajeEdad: campoReq });
				this.mostrarModalAyuda();
			}
		}
	}

	handleBlurEmail = () => {
		const email = document.getElementsByClassName("inputEmail")[0].value;
		this.props.change("email", email);
		$(modal1).modal("hide");
		const elemento = document.getElementsByClassName("textoLabelCorreoFocus")[0];
		const elementoLab = document.getElementsByClassName("textoLabelCorreoLleno")[0];

		if (email === "" || email === undefined) {
			if (elemento !== undefined) {
				elemento.className = 'textoLabelCorreo';
			} else {
				elementoLab.className = 'textoLabelCorreo';
			}
			document.getElementById("complete").innerHTML = '';
		}
	}

	siguiente = () => {
		console.log('siguiente');
		$(modal1).modal("hide");
		const email = document.getElementsByName("email").value;
		const celular = document.getElementsByName("fechaNacimiento").value;
		const fechaNacimiento = document.getElementsByName("telefono_movil").value;
		const rfc = document.getElementsByName("rfc").value;

		if (email === "" || celular === "" || fechaNacimiento === "" || (rfc && rfc === "")) {
			console.log("Existen algun campo vacio");
			this.mostrarModalAyuda();
		} else {
			this.handleBlurCorreo();
			this.handleBlurCel();
		}
	}

	mostrarModalAyuda = () => {		
		if(this.errorsTelefono){
			this.muestraModalAyuda();
		} else
		if(this.errorsCorreo){
			this.muestraModalAyuda();
		} else
		if (this.state.messageEdadBandera) {
			this.muestraModalAyuda();
		} else
		if(btnAyuda !== undefined && btnAyuda === "true"){
			this.muestraModalAyuda();
		} else {
			$(modal1).modal("hide");
			this.setState({ showModalAyuda: false, tipoModalAyuda: ""});
		}
	}

	muestraModalAyuda = () => {
		contador2 = contador2 +1;
		const btnAyuda = localStorage.getItem("btnAyuda"); 

		if(btnAyuda !== undefined && btnAyuda === "true"){
			if(contador2 > 2) {
				this.setState({ showModalAyuda: true, tipoModalAyuda: "error"});
			} else {
				$(modal1).modal("hide");
				this.setState({ showModalAyuda: false, tipoModalAyuda: ""});
			}
		}
	}

	render() {
		const { handleSubmit } = this.props;

		return (
			<form id="myFormulario" onSubmit={handleSubmit(this.whatIWantToRunOnSubmit)}>
				<div className="flex layout-gt-md-row layout-md-row layout-xs-column layout-sm-column layout-align-center-center">
					<StepperPaso2></StepperPaso2>

					<div id="stepperesponsivo">
						<span id="registropaso2"></span>
						<label id="registroletra1">CONTACTO</label>
						<span id="expancion" onClick={this.expandir}></span>
						<div style={{ maxWidth: 380, maxHeight: 400, margin: 'auto' }} id="steppervertical">
							<StepperResposnsivo2></StepperResposnsivo2>
						</div>
					</div>
				</div>

				<div id="div-gral-return">
					<div className="div-return">
						<div className="titulo1">
							<label className="txt-1">Ingresa la información solicitada</label>
						</div>
					</div>
				</div>

				<div className="content-scroll mt-10" onScroll={this.handleScroll}>
					<div className="datos-wrap" style={{ marginTop: "35px" }}>
						<div className="row">

							<div className="col-md-6 col-sm-6 col-xs-12" style={{ marginTop: "21px" }}>
								<div className="input-wrap input-otp mg-bottom-30" id="email-registro">
									<label className={this.clasesLabel} style={{ color: "#567099" }}>Correo electrónico</label>
									<div id="container">
										<div id="complete"></div>
										<input name="email" type="text" id="input" autoComplete="off" maxLength="50"
											onFocus={this.handleFocusEmail.bind(this)} className="inputEmail"
											onKeyPress={this.handleKeyupEmail} style={{ background: "transparent" }}
											onBlur={this.handleBlurEmail}
										/>
									</div>
									<span className="spanCorreo"></span>
								</div>
							</div>

							<div className="col-md-6 col-sm-6 col-xs-12">
								<div className="input-wrap mg-bottom-30 input-error-doble">
									<div className="row">
										<div className="col-xs-8" id="celular-registro">
											<div className="input-wrap input-otp">
												<Field
													name="telefono_movil" max="10" component={campo}
													type="text" label="Teléfono celular"
													onFocus={this.handlefocusCel.bind(this)}
													onChange={this.habilitaBoton.bind(this)}
													error={this.errorsTelefono ? this.msjaMostrar : null}
												/>
											</div>
											{this.state.loadingPequeno ? <div className="spinner" id="spinner-validacion-poliza"></div> : null}
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							{this.props.polizaBanamex === false &&
								<div className="col-md-6 col-sm-6 col-xs-12" style={{ marginTop: "-40px" }}>
									<div className="input-wrap input-otp input-otp-fecha mg-bottom-30" id="email-registro">
										<Field
											component={campo} type={this.state.inputType3}
											name="fechaNacimiento" label="Fecha de Nacimiento"
											onChange={this.handleChange.bind(this)}
											onFocus={this.onFocusFechaNacimiento2.bind(this)}
											onBlur={this.onBlurFechaNacimiento.bind(this)}
											max="10"
										/>
										<span id="calendario-registro" className="material-icons outlined" style={{ marginRight: "0px", marginTop: "-47px", borderBottom: "none" }}
											onClick={this.onFocusFechaNacimiento2.bind(this)}>
											calendar_today
										</span>
										{this.state.messageEdadBandera && <span style={style} >{this.state.mensajeEdad}</span>}
									</div>
								</div>}

							{this.props.grupo && this.props.ramo === "V" &&
								<div className="col-md-6 col-sm-6 col-xs-12">
									<div id="rfc-registro"
										style={{ position: "absolute", width: "52.5%", marginTop: "-42px", marginLeft: "1px" }}>
										<Field
											name="rfc" type="text" component={campo}
											max="15" label="RFC" id="rfc"
											onBlur={this.handleBlurRFC.bind(this)}
										/>
										{this.state.mensajeErrorRFC ?
											<span style={{ color: "red", marginTop: "0px", width: "300px", fontSize: "12px" }}>
												{this.state.mensajeRFC}
											</span> : null}
									</div>
								</div>
							}
						</div>
					</div>

					<Field name="fechaNacimiento" component="input" type="hidden" />
					<Field name="fechaNacimientoDate" component="input" type="hidden" />

					<div className="datos-wrap">
						<div className="row btn-bottom" style={{ "bottom": "15px" }}>
							<div className="col-md-6 col-sm-6 col-xs-12">
								<button className="orange-rectangle" id={elementID} style={{ top: "-40px" }}
									onClick={this.siguiente}>Continuar</button>
							</div>
						</div>
					</div>
				</div>

				{/***********************************  Modales  **************************************/}
				<div className='modal fade' id='modal-validacion1' tabIndex='-1' role='dialog' aria-labelledby='modal-validacion1Label'>
					<div className='modal-dialog' role="document">
						<div className='modal-content'>
							<div className='modal-header'>
								<h4 className='modal-title orange-text' id='modal-validacion1Label'>{this.state.tituloOne}</h4>
							</div>
							<div className='modal-body'><p>{this.state.mensajeOne}</p></div>
							<div className='modal-footer'>
								<button type='button' className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
							</div>
						</div>
					</div>
				</div>

				<div className="modal fade" id="modal-registro-inconcluso"
					tabIndex="-1" role="dialog" aria-labelledby="modal-registro-inconcluso">

					<div className="modal-content modal-content-inconcluso">
						<button type="button" id="btn-cerrar-inconcluso" onClick={this.cancelarInconcluso}>×</button>
						<div id="text-center">
							<h4 id="text-title">
								Estás a un paso de terminar tu registro
							</h4>
						</div>

						<div id="txt-black">
							<label id="txt-mensaje">Previamente iniciaste tu registro con el correo:</label><br />
							<label id="txt-mensaje">{this.correoModal}</label><br />
							<label id="txt-mensaje">Continúa tu registro con el mismo correo dando clic en &#8220;Continuar.&#8221;</label>

							<label id="txt-mensaje" style={{ textAlign: "justify" }}>
								Si deseas empezar de nuevo tu registro comunícate a Línea GNP al 55 5227 9000 opción 7.
							</label>
						</div>

						<div id="footer-modal-inconcluso">
							<button type="button" id="btn-continuar-inconcluso" onClick={this.continuarInconcluso}>Continuar</button>
							<button type="button" id="btn-cancelar-inconcluso" onClick={this.cancelarInconcluso}>&nbsp;&nbsp;Llamar</button>
						</div>

					</div>
				</div>

				<MensajeAyuda onClose={this.cierraTooltip2} show={this.state.showModalAyuda} typeModal={this.state.tipoModalAyuda}></MensajeAyuda>

				<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>
			</form >
		);
	}
}

Datos = reduxForm({ form: "registro-datos" })(Datos);
export default connect(mapState, mapDispatch)(Datos);



// WEBPACK FOOTER //
// ./src/gnp-registro/datos.frm.js